// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PMwJ","clinicsSelect":"styles_clinicsSelect__2jmIN"};